import { PersonRegisterComponent } from '../../components/RegisterSystem/PersonRegisterComponent'
import { HeadTitle } from '../../components/share/HeadTitle'
import { Footer } from "../../components/share/Footer";
// import { NavMenu } from "../../components/NavMenu";
import { NavbarIndexComponent } from "../../components/share/NavbarIndexComponent";

export function PersonRegisterContainer() {
    const titleName = "ลงทะเบียนเข้าใช้งาน";
    return (
        <div className="page-container bg-landing">
            {/* <NavMenu /> */}
            <NavbarIndexComponent />
            <HeadTitle title={titleName} />
            <PersonRegisterComponent />
            <Footer />
        </div>
    );
}